export default {
  postCheck: (state) => {
    return state.postCheck;
  },

  staticCode: (state) => {
    return state.staticCode;
  },

  loadingBtn: (state) => {
    return state.loadingBtn;
  },

  checkAlert: (state) => {
    return state.checkAlert;
  },

  selectedLanguage: (state) => {
    return state.selectedLanguage;
  },

  captcha: (state) => {
    return state.captcha;
  },
};
